import { useQuery } from '@tanstack/react-query';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { formatNumber } from '@/utils/number';
import { instituteSubmissionSummaryQueryOptions } from '../api/instituteSubmissions.api';

interface SeeAllSubmissionsButtonProps {
  userId: number;
  onShowOnlyThisOfficer: (userId: number) => void;
  className?: string;
}

export function SeeAllSubmissionsButton({
  userId,
  onShowOnlyThisOfficer,
  className,
}: SeeAllSubmissionsButtonProps) {
  const { data: officerSummary } = useQuery(
    instituteSubmissionSummaryQueryOptions({ zmUserId: userId }),
  );
  const officerTotal = officerSummary?.total;

  return (
    <Button
      size="sm"
      onClick={() => onShowOnlyThisOfficer(userId)}
      className={cn('group/see-all font-semibold', className)}
    >
      <span>
        See all<span className="max-sm:hidden"> submissions</span>
      </span>
      {officerTotal !== undefined && (
        <span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-primary-foreground px-1 text-3xs font-bold text-primary">
          {formatNumber(officerTotal)}
        </span>
      )}
      <ArrowRight
        data-icon="inline-end"
        className="transition-transform group-hover/see-all:translate-x-0.5 motion-reduce:transition-none"
      />
    </Button>
  );
}
